module.exports = __webpack_public_path__ + "img/Default-J-1.bdeb88af.svg";